var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{attrs:{"id":"New-ad-page-container"}},[_c('LoginRegisterComponent',{attrs:{"onSucceed":_vm.onSucceed}}),_c('div',{staticStyle:{"height":"80px"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }